<template>
  <div class="Progress">
    <v-container fluid >
      <v-toolbar flat color="white">
        <v-toolbar-title>
        <h1> Reporte Médico Covid </h1>
        </v-toolbar-title>
        <v-btn color="green" dark  :disabled="dataVals === null">
          <download-csv
            :data="dataVals"
            :name="csvname + '.csv'"
            :labels="labels"
            :fields="fields"
          >
            <v-icon style="vertical-align: middle" left>cloud_download</v-icon>csv
          </download-csv>
        </v-btn>

        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

      </v-toolbar>
      <data-table
        :headers="headers"
        :dataVals="dataVals"
        :search="search"
        :key="tableKey"
        modo="Reporte Medico"
      />

    </v-container >
  </div>
</template>
<script>
import dataTable from '@/components/Tables/TableBaseCovid'
import JsonCSV from 'vue-json-csv'

export default {

  name: 'Reporte Medico',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
    // 'reporte-personal': TimeLineChart
  },

  data: () => ({
    backConf: {
      path: '/projects/covid/datos/',
      pathFicha: '/projects/covid/timeline/',
      page: 1
    },
    operativo: null,

    url: '/covid/ficha_personal',
    tableKey: 0,

    search: '',
    headers: [
    ],
    dataVals: null,
    csvname: 'ReporteMedico',
    fields: [],
    labels: null

  }),

  computed: {

  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.initialize()
  },

  methods: {
    initialize () {
      this.getReporte()
    },
    getReporte () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.tableKey += 1
          t.updateTable()
        })
        .catch(err => console.error(err))
    },

    /**
     * Función que actualiza los datos de headers de la tabla
     */
    updateTable () {
      let t = this
      console.log('datavals Objects:')
      console.log(Object.keys(t.dataVals[0]))

      let keys = Object.keys(this.dataVals[0])
      // let keys = Object.keys(this.dataVals)
      // keys.pop()

      let head = []
      let labs = []

      keys.forEach(function (k, index) {
        head.push(
          { text: k, value: k, str: ' ', width: '2%', align: '' }
        )
        labs[k] = k
      })

      // // labs.total = 'Respuestas'
      // // labs.percentage = 'Porcentaje'

      this.headers = head

      // labels para el csv que descargan
      this.labels = labs
      this.fields = Object.keys(this.dataVals[0])

      // // this.fields = Object.keys(this.dataVals[0])
    }

  }
}
</script>
